/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import {
  ScopedTabbedView
} from '../'

import {
  isBase64
} from '../../utils'

const getEmployerPayrollcycles = gql`
  query($id: ID!) {
    employer(id: $id) {
      id
      payrollcycles {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`

export default class EmployerPayrollCycleTabs extends React.PureComponent {
  static propTypes = {
    employerId: PropTypes.string.isRequired,
    children: PropTypes.func,
    onClick: PropTypes.func,
    initialActiveTab: PropTypes.string
  }

  render() {
    return (
      <Query query={getEmployerPayrollcycles} variables={{ id: this.props.employerId }}>
        {({ loading, error, data }) => {
          if (loading || error) {
            return null
          }

          let payrollCycles = data.employer.payrollcycles.edges
          let initialActiveTabIndex = payrollCycles.findIndex(payrollCycle => (
            payrollCycle.node.id === this.props.initialActiveTab
          ))

          // next block of code is used to determine whether content corresponding to the first tab needs to be displayed
          if (payrollCycles.length > 0 && !isBase64(this.props.initialActiveTab)) {
            this.props.onClick(payrollCycles[0].node.id)
          }

          return (
            <ScopedTabbedView
              tabs={
                payrollCycles.map(({ node: payrollCycle }) => payrollCycle.name)
              }
              contents={
                this.props.children
                  ? payrollCycles.map(({ node: payrollCycle }) => (
                      this.props.children(payrollCycle.id)
                    ))
                  : []
              }
              onClick={tabIndex => {
                let payrollCycle = payrollCycles[tabIndex].node
                this.props.onClick(payrollCycle.id)
              }}
              initialActiveTabIndex={initialActiveTabIndex > -1
                ? initialActiveTabIndex
                : null
              }
            />
          )
        }}
      </Query>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/employer-payrollcycle-tabs/index.js